import { ListMessageAppearances, ListMessageAppearancesVariables } from './__generated__/ListMessageAppearances'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListMessageAppearances($id: String!, $cursor: String) {
    listBoardMessageAppearancesV2(input: { boardId: $id, cursor: $cursor, limit: 11 }) {
      messageAppearances {
        id
        message {
          id
          text
        }
        attribution
        created
        sentAt
      }
      nextCursor
    }
  }
`

export const useMessageHistory = ({ boardId, cursor }: { boardId: string; cursor: string | null }) =>
  useQuery<ListMessageAppearances, ListMessageAppearancesVariables>(QUERY, {
    variables: { id: boardId, cursor }
  })
